import React from 'react';
import styles from './SalesByCategory.module.scss';
import { PriceFormat, Spinner } from 'components/UI';
import { SalesByCategoryReport } from 'model/SalesByCategoryReport';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

interface CategoryTableProps {
    loading: boolean;
    report: SalesByCategoryReport;
}

const CategoryTable: React.FC<CategoryTableProps> = ({ loading, report }) => {
    if (loading) {
        return (
            <div className={styles.tableWrapper}>
                <Spinner />
            </div>
        );
    }

    return (
        <div className={styles.tableWrapper}>
            <div className={styles.tableHeaderRow}>
                <div></div>
                <div>Quantity</div>
                <div>Gross Sales</div>
                <div>Discounts</div>
                <div>
                    Refunds
                    <Tooltip
                        content="Refunds are proportionally allocated from order-level refunds"
                        placement="top"
                        className={styles.customTooltip}
                    >
                        <div>
                            <FontAwesomeIcon
                                icon={faInfoCircle}
                                className={styles.tooltipIcon}
                            />
                        </div>
                    </Tooltip>
                </div>
                <div>Net Sales</div>
                <div>% of Net Sales</div>
            </div>

            {report.categories.map((c, idx) => (
                <div
                    key={`${c.key}-${idx}`}
                    className={styles.categoryRow}
                >
                    <div className={styles.nameCell}>{c.label}</div>
                    <div className={styles.quantityCell}>{c.quantity}</div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={c.grossSales.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={c.discounts.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={c.refunds.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={c.netSales.toFixed(2)} />
                    </div>
                    <div className={styles.percentCell}>{(c.netSalesPct * 100).toFixed(2)}%</div>
                </div>
            ))}

            {report.categories.length > 0 && (
                <div className={`${styles.categoryRow} ${styles.totalRow}`}>
                    <div className={styles.nameCell}>Total</div>
                    <div className={styles.quantityCell}>{report.totals.quantity}</div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={report.totals.grossSales.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={report.totals.discounts.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={report.totals.refunds.toFixed(2)} />
                    </div>
                    <div className={styles.amountCell}>
                        <PriceFormat price={report.totals.netSales.toFixed(2)} />
                    </div>
                    <div className={styles.percentCell}>{report.totals.netSales > 0 ? '100.00' : '0.00'}%</div>
                </div>
            )}
        </div>
    );
};

export default CategoryTable;
